import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";

type ScopeChipProps = {
    label: string;
    value: string;
    children: (close: () => void) => React.ReactNode;
    isActive: boolean;
    isDisabled?: boolean;
};

export function ScopeChip({ label, value, children, isActive, isDisabled = false }: ScopeChipProps) {
    return (
        <Popover className="relative">
            <PopoverButton
                disabled={isDisabled}
                className={`inline-flex max-w-[190px] items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] transition-colors focus:outline-none focus:ring-0 data-[focus]:outline-none data-[focus]:ring-0 disabled:cursor-default disabled:opacity-60 ${
                    isActive
                        ? "border-primary/40 bg-primary/[0.07] text-gray-900"
                        : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50"
                }`}
            >
                <span className="text-gray-400">{label}</span>
                <span className="truncate font-medium">{value}</span>
                <ChevronUpDownIcon className="h-3 w-3 shrink-0 text-gray-400" />
            </PopoverButton>
            <PopoverPanel
                anchor={{ to: "top start", gap: 6 }}
                className="z-[60] w-64 rounded-xl border border-gray-200 bg-white p-1 shadow-lg ring-1 ring-black/5 focus:outline-none"
            >
                {({ close }) => <>{children(close)}</>}
            </PopoverPanel>
        </Popover>
    );
}
